export default {
  translation: {
    top: {
      information: '太陽光発電システム情報',
      capacity: 'システム容量',
      commissioning: '操業開始',
      energyToday: '本日の発電量',
      totalEnergy: '合計',
      temperature: '温度',
    },
    middle: {
      solarPower: '本日の発電グラフ',
      currentSolar: '現在の出力',
    },
    bottom: {
      co2_1: '本日の',
      co2_2: '削減量',
      total: '合計',
      savingMoney: '本日の節電金額', 
      totalSave : '合計' 
    }
  },
}
